module.exports = __webpack_public_path__ + "media/assets/services_manager/flags/australia-785731a14e404bef5c87fe7a2d76822c93a2b0f2c1b5a84a955b174777253353.png";